// Enquadramento do logo da empresa no cartão central da página inicial (editor em Configurações).
// Funções puras; o back valida as mesmas faixas (EmpresaLogoService.validar).
//
// modo   CONTER (logo inteiro, sobra fundo) | PREENCHER (ocupa o cartão todo, corta as sobras)
// zoom   50 a 300 (%)
// posX/posY  0 a 100 (%): ponto do logo que fica no ponto correspondente do cartão (no PREENCHER, escolhe o corte)
// corFundo   #RRGGBB, a cor do cartão em volta do logo

export const AJUSTE_PADRAO = { modo: 'CONTER', zoom: 100, posX: 50, posY: 50, corFundo: '#FFFFFF' };
export const ZOOM_MIN = 50;
export const ZOOM_MAX = 300;

const limitar = (v, min, max, padrao) => {
  const n = Number(v);
  return Number.isFinite(n) ? Math.min(max, Math.max(min, Math.round(n))) : padrao;
};

// Completa o que faltar com o padrão e põe cada valor na faixa
export function normalizarAjuste(ajuste) {
  const a = ajuste || {};
  const cor = String(a.corFundo || '').toUpperCase();
  return {
    modo: a.modo === 'PREENCHER' ? 'PREENCHER' : 'CONTER',
    zoom: limitar(a.zoom, ZOOM_MIN, ZOOM_MAX, AJUSTE_PADRAO.zoom),
    posX: limitar(a.posX, 0, 100, AJUSTE_PADRAO.posX),
    posY: limitar(a.posY, 0, 100, AJUSTE_PADRAO.posY),
    corFundo: /^#[0-9A-F]{6}$/.test(cor) ? cor : AJUSTE_PADRAO.corFundo,
  };
}

// Estilos do cartão e da imagem (a imagem ocupa o cartão inteiro, posição absoluta)
export function estiloDoLogo(ajuste) {
  const a = normalizarAjuste(ajuste);
  const ponto = `${a.posX}% ${a.posY}%`;
  return {
    cartao: { backgroundColor: a.corFundo },
    imagem: {
      objectFit: a.modo === 'PREENCHER' ? 'cover' : 'contain',
      objectPosition: ponto,
      transform: `scale(${a.zoom / 100})`,
      transformOrigin: ponto,
    },
  };
}

// Cor da borda do logo (média dos pixels da moldura, ignorando os transparentes), para o fundo do cartão
// continuar o fundo do próprio logo. pixels: RGBA (ImageData.data). Sem pixel visível na borda: null.
export function corDaBorda(pixels, largura, altura) {
  let r = 0, g = 0, b = 0, n = 0;
  const somar = (x, y) => {
    const i = (y * largura + x) * 4;
    if (pixels[i + 3] < 200) return;
    r += pixels[i]; g += pixels[i + 1]; b += pixels[i + 2]; n++;
  };
  for (let x = 0; x < largura; x++) { somar(x, 0); somar(x, altura - 1); }
  for (let y = 1; y < altura - 1; y++) { somar(0, y); somar(largura - 1, y); }
  if (!n) return null;
  const hex = (v) => Math.round(v / n).toString(16).padStart(2, '0');
  return `#${hex(r)}${hex(g)}${hex(b)}`.toUpperCase();
}
